import React from 'react'
import PropTypes from 'prop-types';

function Background({ imgSrc }) {
  return (
    <div className='bg-wrapper'>
      <img src={imgSrc} alt="" />
    </div>
  )
}

Background.propTypes = {
  imgSrc: PropTypes.string.isRequired,
};

export default Background
